export default __webpack_public_path__ + "static/media/Milanovski.6bfb842c.png";